import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

import AppComponentHeader from "@/components/app/AppComponentHeader.vue";
import { useStore } from "vuex";
import { computed } from "vue";
import { WebPushStatus } from "@/store/modules/webPush";
import { ClassesProp } from "@/types/app";
import AppIcon from "@/components/app/AppIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebPushSubscribeForm',
  setup(__props) {


const store = useStore()

const isBrowserSupported = computed(() => store.getters["webPush/isSupported"])
const webPushInitHandled = computed(() => store.getters["webPush/isInitialized"])
const webPushStatus = computed(() => store.getters["webPush/getWebPushStatus"])

const badgeClass = computed((): ClassesProp => {
  return {
    'bg-success': WebPushStatus.GRANTED === webPushStatus.value,
    'bg-danger': WebPushStatus.DENIED === webPushStatus.value,
    'bg-secondary': [WebPushStatus.DEFAULT, WebPushStatus.PROMPT].includes(webPushStatus.value)
  }
})

const buttonSubscribeIsAllowed = computed((): boolean => {
  return [WebPushStatus.DEFAULT, WebPushStatus.PROMPT].includes(webPushStatus.value)
})

function onSubscribeWebPushClick () {
  return store.dispatch('webPush/subscribe')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Notifications")
      ]),
      _: 1
    }),
    (_unref(isBrowserSupported))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", null, [
            (_unref(webPushInitHandled))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["badge bg-secondary", _unref(badgeClass)])
                }, _toDisplayString(_unref(webPushStatus)), 3))
              : (_openBlock(), _createBlock(AppIcon, {
                  key: 1,
                  icon: "spinner",
                  spin: ""
                }))
          ]),
          (_unref(buttonSubscribeIsAllowed))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: onSubscribeWebPushClick
              }, " Allow web push "))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})